import MainLayout from '../layouts/main';
import OrderContainer from './container';

function OrderPage() {
  return (
    <MainLayout>
      <OrderContainer />
    </MainLayout>
  );
}

export default OrderPage;
